import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZendeskRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1571 1190",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M725.9 314.2v875.4H.6zM.7.1A362 362 0 0 0 107 256.3a362 362 0 0 0 512.8 0A363 363 0 0 0 725.9.1zm1570 1189.6a363 363 0 0 0-362.6-362.6 362.5 362.5 0 0 0-362.7 362.6zM845.5 875.4 1570.9.1H845.5z"
	})
});
export default SvgZendeskRegularIcon;
